import { useSonarSelector } from './useSonarSelector';
/**
 * Subscribes to a collection of state {@link AsyncSelectors} and provides the associated state data and flags.
 * @param selectors Async selectors collection object for an async state.
 * @returns An {@link UseAsyncStateResult} instance with state data and flags.
 */
export function useAsyncState(selectors) {
    const data = useSonarSelector(selectors.data);
    const isErrored = useSonarSelector(selectors.isErrored);
    const isFailed = useSonarSelector(selectors.isFailed);
    const isIdle = useSonarSelector(selectors.isIdle);
    const isReceived = useSonarSelector(selectors.isReceived);
    const isRequested = useSonarSelector(selectors.isRequested);
    return {
        data,
        isErrored,
        isFailed,
        isIdle,
        isReceived,
        isRequested
    };
}
